var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GmapComponent } from './gmap.component';
import { GmapsTravelMode } from './../common-theme/gmaps/gmaps-interface/gmaps-travel-mode.model';
import { OnInit, AfterViewInit, Injector, OnDestroy } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { GmapsPoint } from '../common-theme/gmaps/gmaps-point.model';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
var LocalisationComponent = /** @class */ (function (_super) {
    __extends(LocalisationComponent, _super);
    function LocalisationComponent(agencyService, injector, _scrollToService, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.injector = injector;
        _this._scrollToService = _scrollToService;
        _this.translateService = translateService;
        _this.travelModes = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        _this.pointsOfInterestCategories = [];
        return _this;
    }
    LocalisationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.travelModes = [
            new GmapsTravelMode('drive', 'assets/icons/gmaps/car.svg'),
            new GmapsTravelMode('transit', 'assets/icons/gmaps/transit.svg'),
            new GmapsTravelMode('walk', 'assets/icons/gmaps/walk.svg')
        ];
        this.pointsOfInterestCategories = this.getCategories(this.getInterestPoints());
        this.getTextAddition();
        this.subscription.add(this.translateService.onLangChange
            .subscribe(function () {
            _this.pointsOfInterestCategories = _this.getCategories(_this.getInterestPoints());
            _this.getTextAddition();
        }));
        this.setTitle('Localizarea proiectului imobiliar Dream Residence - Rahova nou');
        this.setMetaDescription("Te afli intr-un cartier rezidential aparte, langa punct de livrare Emag, targ Pucheni, En-Gross Pucheni, targul Pucheni. Detalii pe site.");
    };
    LocalisationComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.translateSubscription.unsubscribe();
    };
    LocalisationComponent.prototype.ngAfterViewInit = function () {
        this.googleMap.initGmapsDirections(new GmapsPoint(parseFloat(this.agencyService.agency.latitude.toString()), parseFloat(this.agencyService.agency.longitude.toString())), undefined, this.googleMap.interface.locationSearchInput.destinationRef);
    };
    LocalisationComponent.prototype.getTextAddition = function () {
        var _this = this;
        this.translateSubscription.add(this.translateService.get('model.gmaps.additional_text')
            .subscribe(function (translatedString) {
            _this.textAddition = translatedString;
        }));
    };
    LocalisationComponent.prototype.getInterestPoints = function () {
        var interestPoints = [];
        var _loop_1 = function (i) {
            var interestPoint = {
                title: '',
                latitude: '',
                longitude: '',
                category_id: ''
            };
            this_1.translateSubscription.add(this_1.translateService.get('points_of_interest.' + i + '.title')
                .subscribe(function (translatedString) {
                interestPoint.title = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('points_of_interest.' + i + '.category_id')
                .subscribe(function (translatedString) {
                interestPoint.category_id = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('points_of_interest.' + i + '.latitude')
                .subscribe(function (translatedString) {
                interestPoint.latitude = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('points_of_interest.' + i + '.longitude')
                .subscribe(function (translatedString) {
                interestPoint.longitude = translatedString;
            }));
            interestPoints.push(interestPoint);
        };
        var this_1 = this;
        for (var i = 0; i <= 49; i++) {
            _loop_1(i);
        }
        return interestPoints;
    };
    LocalisationComponent.prototype.getCategories = function (interestPoints) {
        var categories = [];
        var _loop_2 = function (i) {
            var interestPointsCat = {
                title: '',
                icon: '',
                points: []
            };
            this_2.translateSubscription.add(this_2.translateService.get('poi_categories.' + i + '.title')
                .subscribe(function (translatedString) {
                interestPointsCat.title = translatedString;
            }));
            this_2.translateSubscription.add(this_2.translateService.get('poi_categories.' + i + '.icon')
                .subscribe(function (translatedString) {
                interestPointsCat.icon = translatedString;
            }));
            interestPointsCat.points = interestPoints.filter(function (ip) { return parseInt(ip.category_id) === i; });
            categories.push(interestPointsCat);
        };
        var this_2 = this;
        for (var i = 1; i <= 7; i++) {
            _loop_2(i);
        }
        return categories;
    };
    LocalisationComponent.prototype.onInterestPointClick = function (point) {
        this.googleMap.updatePath(point.latitude, point.longitude, this.textAddition + " " + point.title);
        this.triggerScrollTo('map');
    };
    LocalisationComponent.prototype.triggerScrollTo = function (target) {
        var config = {
            target: target
        };
        this._scrollToService.scrollTo(config);
    };
    return LocalisationComponent;
}(SeoAwareBaseComponent));
export { LocalisationComponent };



// WEBPACK FOOTER //
// ./src/app/localisation/localisation.component.ts.pre-build-optimizer.js